export default "__VITE_ASSET__D03b1jaa__"